import { memo } from 'react';
import { WizardOption } from '../../types/suggestionWizard';

interface OptionButtonsProps {
  options: WizardOption[];
  onSelect: (value: string, label: string) => void;
}

/**
 * Option buttons for wizard selection steps.
 * Displays clickable cards with label and optional description.
 */
export const OptionButtons = memo<OptionButtonsProps>(({ options, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 mt-1">
      {options.map((opt) => (
        <button
          type="button"
          key={opt.value}
          onClick={() => onSelect(opt.value, opt.label)}
          className="group px-3 py-2 bg-white border border-gray-200 rounded-lg hover:border-gray-400 hover:bg-gray-50 transition-all text-left"
        >
          <span className="text-[13px] font-medium text-gray-800 group-hover:text-gray-900">
            {opt.label}
          </span>
          {opt.description && (
            <p className="text-[11px] text-gray-400 mt-0.5">{opt.description}</p>
          )}
        </button>
      ))}
    </div>
  );
});

OptionButtons.displayName = 'OptionButtons';

export default OptionButtons;
